import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function RegisterGuest() {
  const [formData, setFormData] = useState({ email: '', username: '', password: '', full_name: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/auth/register-guest', formData);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed.');
    }
  };

  if (success) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'var(--bg-apex)' }}>
        <div className="glass-card animate-fade" style={{ width: '100%', maxWidth: '440px', padding: '3rem', textAlign: 'center' }}>
          <div style={{
            background: 'rgba(34, 197, 94, 0.15)', width: '80px', height: '80px', borderRadius: '50%',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'
          }}>
            <span style={{ fontSize: '2.5rem' }}>&#10003;</span>
          </div>
          <h2 style={{ color: 'var(--text-heading)', marginBottom: '1rem' }}>Welcome to AP NEO</h2>
          <p style={{ color: 'var(--text-body)', marginBottom: '2rem' }}>Your guest account has been created. You can now log in and explore.</p>
          <Link to="/login" className="btn-cyber" style={{ display: 'inline-block', padding: '1rem 2.5rem', textDecoration: 'none' }}>
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh',
      background: 'var(--bg-apex)',
      backgroundImage: 'radial-gradient(circle at center, rgba(99, 102, 241, 0.05), transparent 70%)'
    }}>
      <div className="glass-card animate-fade" style={{ width: '100%', maxWidth: '440px', padding: '3rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            background: 'var(--accent-primary)',
            width: '80px', height: '80px', borderRadius: '20px', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: '2rem',
            boxShadow: 'var(--glow-indigo)'
          }}>
            <span style={{ fontWeight: 900, color: 'var(--btn-text)', fontSize: '2.5rem' }}>A</span>
          </div>
          <h2 style={{ fontSize: '2rem', color: 'var(--text-heading)', marginBottom: '0.75rem', letterSpacing: '-0.03em' }}>
            Guest Access
          </h2>
          <p style={{ color: 'var(--text-body)', fontSize: '0.95rem', fontWeight: 500 }}>
            Create a guest account to explore AP NEO
          </p>
        </div>

        {error && (
          <div style={{
            background: 'rgba(244, 114, 182, 0.1)', border: '1px solid rgba(244, 114, 182, 0.2)',
            color: 'var(--accent-magenta)', padding: '1rem', borderRadius: '12px',
            marginBottom: '1.5rem', textAlign: 'center', fontSize: '0.85rem', fontWeight: 600
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginLeft: '0.5rem' }}>Full Name</label>
            <input
              className="cyber-input"
              type="text"
              placeholder="Your full name"
              value={formData.full_name}
              onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginLeft: '0.5rem' }}>Email Address</label>
            <input
              className="cyber-input"
              type="email"
              placeholder="you@example.com"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginLeft: '0.5rem' }}>Username</label>
            <input
              className="cyber-input"
              type="text"
              placeholder="Choose a username"
              required
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginLeft: '0.5rem' }}>Password</label>
            <input
              className="cyber-input"
              type="password"
              placeholder="Min. 6 characters"
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            />
          </div>

          <button type="submit" className="btn-cyber" style={{ marginTop: '1rem', padding: '1.25rem' }}>
            Create Guest Account
          </button>
        </form>

        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', fontWeight: 500 }}>
            Already have an account?
            <Link to="/login" style={{ color: 'var(--accent-primary)', fontWeight: 700, marginLeft: '0.5rem', textDecoration: 'none' }}>
              Sign In
            </Link>
          </p>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', fontWeight: 500, marginTop: '0.75rem' }}>
            Have an invite link?
            <Link to="/register-invite" style={{ color: 'var(--accent-cyan)', fontWeight: 700, marginLeft: '0.5rem', textDecoration: 'none' }}>
              Register with Invite
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegisterGuest;
